import {SalutationsList} from "./SalutationsList";
import {SalutationsEdit} from "./SalutationsEdit";
import {SalutationsCreate} from "./SalutationsCreate";

export default {
    list: SalutationsList,
    create: SalutationsCreate,
    edit: SalutationsEdit
};
